import { z } from "zod";
export const OrganizationCRMMetadataSchema = z.object({}).passthrough().partial();
export const OrganizationLocalizationIntegrationLokaliseSchema = z.object({
    provider: z.literal("lokalise"),
    projectId: z.string().optional(),
    webhook: z.object({
        id: z.string().optional(),
        url: z.string().optional(),
        secret: z.string().optional()
    }).optional(),
    apiKey: z.string().transform((value)=>{
        return value.trim();
    })
});
export const OrganizationLocalizationIntegrationCrowdinSchema = z.object({
    provider: z.literal("crowdin"),
    // I don't love coercing, I think it'll have some unintended consequences.
    projectId: z.coerce.number().optional(),
    apiKey: z.string().transform((value)=>{
        return value.trim();
    }),
    crowdinOrganization: z.string().optional(),
    webhook: z.object({
        id: z.number().optional(),
        url: z.string().optional()
    }).optional()
});
export const OrganizationLocalizationIntegrationSchema = z.discriminatedUnion("provider", [
    OrganizationLocalizationIntegrationLokaliseSchema,
    OrganizationLocalizationIntegrationCrowdinSchema
]);
